import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, of } from 'rxjs';
import * as Global from '../Model/CommanHttp';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LiveBiddingViewService {

  constructor(private http: HttpClient) { }


  FillLiveAuctionList(Ind: number, OrgCode: number, CityCode: number) {
    return this.http.get(`${Global.base_url}/LiveBiddingView/FillLiveAuction?Ind=` + Ind + '&OrgCode=' + OrgCode + '&CityCode=' + CityCode, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('FillLiveAuction')));
  }
  FillBiddingTop5List(Ind: number, OrgCode: number, CityCode: number, AuctionID: number) {
    return this.http.get(`${Global.base_url}/LiveBiddingView/FillBiddingTop5List?Ind=` + Ind + '&OrgCode=' + OrgCode + '&CityCode=' + CityCode + '&AuctionID=' + AuctionID , Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('FillBiddingTop5List')));
  }

  //For Error Handling
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
